// extracted by mini-css-extract-plugin
export var radioInputRow = "w_r3";
export var radioInputColumn = "w_r4";
export var inputOptionRow = "w_pT";
export var inputOptionColumn = "w_pV";